export const downloadFile = (data: Blob, fileName: string): void => {
  const link = document.createElement("a");
  link.href = window.URL.createObjectURL(data);
  link.setAttribute("download", fileName);
  link.click();
  link.remove();
};
